import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Label } from '@miroculus/nucleo';
import styles from './FormField.scss';
const cx = classNames.bind(styles);
const FormField = memo(({ title, children }) => (React.createElement("div", { className: cx('field') },
    React.createElement(Label, null,
        React.createElement("p", null, title),
        children))));
export default FormField;
